import { ElementRef, Injectable } from "@angular/core";
import { Broadcaster } from "app/components/service/Broadcaster";
import { Cookie } from "../class/cookie";
import { SingService } from "app/components/service/sing.service";
import { GeneralService } from "app/components/class/general.service";
import { SingIn } from "../class/sing-in";
import { responseGetUser } from "app/components/class/http/res/response-get-user";
import { TableData } from "app/components/class/table-data";
import { showAddCampaignMode } from "app/components/class/broadcaster/add-campaign/show-add-campaign-mode";
import { updateInfoItem } from "app/components/class/broadcaster/update-info-item";
import { updateCategories } from "app/components/class/broadcaster/update-categories";
import { renameCategori } from "app/components/class/broadcaster/rename/rename-categori";
import { requestXLSBudget } from "app/components/class/http/req/request-xls-budget";

@Injectable()
export class Action {
    blockMask: boolean = false;
    Cookie: Cookie = new Cookie();
    getParams: any;
    tableData: TableData = new TableData();
    UpdateRofftops: boolean = false;
    sub: any; // get параметры
    UpdateClients: boolean = false;
    countCategories: number = 0;
    constructor(private elRef: ElementRef, private broadcaster: Broadcaster, private httpService: SingService, public generalService: GeneralService) {

    }
    public onInit() {
        this.broadcaster.on<any>("setblockmask").subscribe((data: boolean) => {
            this.blockMask = data;
        });
        this.broadcaster.on<any>("updateSettings").subscribe((data: TableData) => {
            this.tableData.setData(data.settings);
        });
        this.broadcaster.on<any>("updateCategories").subscribe((data: updateCategories) => {
            this.countCategories = data.categories.length;
        });
    }
    public getAuthData() {
        return this.httpService.getAuthData();
    }
    public updateCookie() {
        if (window.location.search.indexOf("?id=") > (-1)) {
            document.cookie = `client_id=${window.location.search.replace("?id=", "")};max-age=${this.Cookie.maxAge};domain=${this.Cookie.domain};`;
        }
    }
    public getClients() {
        return this.httpService.getClients()
    }
    public singIn(data: SingIn) {
        return this.httpService.singIn(data);
    }
    public IsEmail(email: string): boolean {
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }
    public AuthError() {
        window.localStorage.clear();
        document.cookie = `loggedIn=;domain=${this.Cookie.domain};`;

        // window.localStorage.setItem("lastUrl", window.location.pathname + window.location.search);
        document.cookie = `client_id=${window.location.search.replace("?id=", "")};max-age=${this.Cookie.maxAge};domain=${this.Cookie.domain};`;
        window.location.href = "/";
    }
    public clearUserData(Cookie: any) {
        window.localStorage.clear();

        document.cookie = `loggedIn=;domain=${Cookie.domain};`;

        window.location.href = "/";
    }
    getAuthCookie(): string {
        // return document.cookie.replace(/(?:(?:^|.*;\s*)access_token\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        let cookie = document.cookie.replace(/(?:(?:^|.*;\s*)loggedIn\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        return (cookie.length === 1) ? "" : cookie;
    }
    public setDataUser(data: responseGetUser, clients: any) {
      
        document.cookie = `loggedIn=${this.getAuthCookie()};path=${this.Cookie.path};max-age=${this.Cookie.maxAge};domain=${this.Cookie.domain};`;
        window.localStorage.setItem(
            "identity",
            JSON.stringify(data),
        );
        if (window.localStorage.getItem("clientId")) {
            let clientLast: number = Number(window.localStorage.getItem("clientId"));
            let indexClient: number = clients.findIndex(element => element.id === clientLast);
            if (indexClient !== (-1)) {
                window.localStorage.setItem("clientId", String(clientLast));
                window.location.href = `/rtb?id=${clientLast}`;
            }
            else {
                window.localStorage.setItem("clientId", String(clients[0].id));
                window.location.href = `/rtb?id=${clients[0].id}`;
            }

        }
        else {
            window.localStorage.setItem("clientId", String(clients[0].id));
            window.location.href = `/rtb?id=${clients[0].id}`;
        }

    }

    public LogOut() {
        this.httpService.LogOut().subscribe(data => {
            if (data.status === 200) {
                this.clearUserData(this.Cookie);
            }
        });
    }
    public onClosedInfo() {
        this.broadcaster.broadcast("updateInfoItem", new updateInfoItem({
            id: null,
            action: "closed"
        }));
    }
    public onClosedAllwhite() {
        if (this.blockMask) return;
        this.broadcaster.broadcast("showAddCampaignMode", new showAddCampaignMode({
            action: "closed",
        }));
        this.broadcaster.broadcast("Confirm", {
            data: null,
        });
        this.broadcaster.broadcast("closedAlert", {
            action: "closed",
        });

        this.broadcaster.broadcast("renameCategori", new renameCategori(null,null,"closed"));
        this.broadcaster.broadcast("showExportPDF", {
            action: "closed"
        });
        this.broadcaster.broadcast("showExportCSV", {
            action: "closed"
        });
        this.broadcaster.broadcast("showChangeSumm", null);


    }
    public onGoToMain() {
        history.replaceState({}, "some title", "/");
        window.location.href = "/";
    }
    public onClosedErrorMask() {
        this.elRef.nativeElement.querySelector(".info-error-mask").style.display = "none";
        this.elRef.nativeElement.querySelector(".info-error").style.display = "none";
    }
    public showSales() {
        this.broadcaster.broadcast("showSalesObjectives", null);
    }
    public DownloadPdf() {
        this.broadcaster.broadcast("showExportPDF", null);

    }
    public getXLSBudget (data:requestXLSBudget) {
      return  this.httpService.getXLSBudget(data);
    }
    public UpdateFirst(path: string): String {
        if (window.location.pathname === "/") return "";
        if (path.indexOf(window.location.pathname) !== (-1)) {
            return "m--active";
        }
        return "";
    }
    public getUrlAdmin() {
        return `http://admin.${document.domain}${(location.port !== "") ? ":" + location.port : ""}/`;
    }
    public getUrlScraper() {
        return `http://inventory-scraper.${document.domain}${(location.port !== "") ? ":" + location.port : ""}/`;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/app/services/action.service.ts